import { CommissionRateTemplate } from '@models/commission-rates';
import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { apiClient } from '.';

export const createCommissionRateTemplate = async (body: CommissionRateTemplate) => {
  return apiClient.post<CommissionRateTemplate>(`/admin/v1/commission-rates/templates`, body);
};

export const searchCommissionRateTemplates = async (query?: SearchPagenateQuery) => {
  return apiClient.get<PagenatedResponse<CommissionRateTemplate>>(`/admin/v1/commission-rates/templates`, {
    params: query,
  });
};

export const deleteCommissionRateTemplate = async (templateId: string) => {
  return apiClient.delete(`/admin/v1/commission-rates/templates/${templateId}`);
};

export const updateCommissionRateTemplate = async (data: {
  templateId: string;
  body: Partial<CommissionRateTemplate>;
}) => {
  const templateId = data.templateId;
  return apiClient.put<CommissionRateTemplate>(`/admin/v1/commission-rates/templates/${templateId}`, data.body);
};
